'use strict';

var angular = require('angular');
var ManagementAccessRequestsController = function ManagementAccessRequestsController($scope, dataRetrieverService, userManagementCommonCustomRenderers, userSummaryBoxService, userSecureService, userManagementConstants) {
  $scope.customRenderers = userManagementCommonCustomRenderers;
  dataRetrieverService.getDataRetriever('USER_MANAGEMENT_SCREEN', 'user-management-manage-access-requests-mode').setCustomSearchCriteriaRules([]);
  $scope.$on('grid:beforeUpdateBoundData', function (event, data) {
    $scope.pendingUsers = data.length;
  });
  $scope.selectedUser = null;
  function checkAvailableUserAccounts() {
    userSummaryBoxService.getUserNumbers().then(function (userSummary) {
      if (userSummary.availableUserAccounts <= 0) {
        angular.element('#reach-max-warning-modal').modal('show');
      } else {
        angular.element('#reach-max-warning-modal').modal('hide');
      }
    });
  }
  $scope.pendingUserDetail = function (selectedUser) {
    if (typeof selectedUser.entityData.isSabreEmployee === 'undefined' || !selectedUser.entityData.isSabreEmployee) {
      checkAvailableUserAccounts();
    }
    userSecureService.retrieveSpecifiedUser(selectedUser.entityData.userId).then(function (userData) {
      $scope.userData = userData;
      $scope.userManagementState = userManagementConstants.MANAGE_USERS_SCREENS.PENDING_USER_REQUEST;
    });
  };
  $scope.$on('user-management-manage-users:change-screen', function onChangeScreen(event, value) {
    $scope.userManagementState = value;
  });
  $scope.buttonText = 'Back to user list';
  $scope.destScreen = userManagementConstants.SCREEN_VALUE.MANAGE_USERS;
};
ManagementAccessRequestsController.$inject = ['$scope', 'DataRetrieverService', 'UserManagementCommonCustomRenderers', 'UserSummaryPanelService', 'UserSecureService', 'UserManagementConstants'];
module.exports = ManagementAccessRequestsController;